import { faAdd, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { FieldArray } from 'formik';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { Education } from './candidateEducationForm.type';
import Input from 'components/common/form/input/Input';
import Select from 'components/common/form/select/Select';
import { educationOptions } from './config';

function CandidateEducationForm() {
  return (
    <FieldArray name="education">
      {({ form: { values }, push, remove }) => {
        return (
          <>
            <header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0 text-body-highlight">Education</h5>
              <Button
                variant="link"
                startIcon={<FontAwesomeIcon icon={faAdd} className="me-2" />}
                onClick={() =>
                  push({
                    level: '',
                    degree: '',
                    college: '',
                    startData: '',
                    endDate: ''
                  })
                }
              >
                Add Education
              </Button>
            </header>
            {values.education.map((_: Education, index: number) => {
              const levelName = `education[${index}].level`;
              const degreeName = `education[${index}].degree`;
              const collegeName = `education[${index}].college`;
              const startDataName = `education[${index}].startDate`;
              const endDateName = `education[${index}].endDate`;
              return (
                <Row key={index} className="g-5 border-bottom pb-4 mb-4">
                  <Col xs={12} xl={6}>
                    <FormGroup className="text-start">
                      <FormLabel htmlFor={levelName}>
                        Level of education
                      </FormLabel>
                      <Select
                        name={levelName}
                        id={levelName}
                        options={educationOptions}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} xl={3}>
                    <FormGroup className="text-start">
                      <FormLabel htmlFor={degreeName}>Degree</FormLabel>
                      <Input name={degreeName} id={degreeName} />
                    </FormGroup>
                  </Col>
                  <Col xs={12} xl={3}>
                    <FormGroup className="text-start">
                      <FormLabel htmlFor={collegeName}>College</FormLabel>
                      <Input name={collegeName} id={collegeName} />
                    </FormGroup>
                  </Col>
                  <Col xs={12} xl={3}>
                    <FormGroup className="text-start">
                      <FormLabel htmlFor={startDataName}>Start date</FormLabel>
                      <Input
                        name={startDataName}
                        id={startDataName}
                        type="date"
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} xl={3}>
                    <FormGroup className="text-start">
                      <FormLabel htmlFor={endDateName}>End date</FormLabel>
                      <Input name={endDateName} id={endDateName} type="date" />
                    </FormGroup>
                  </Col>
                  <Col xs={12} xl={3}>
                    <div className="d-flex align-items-center h-100">
                      <Button
                        variant="link"
                        startIcon={
                          <FontAwesomeIcon icon={faTrash} className="me-2" />
                        }
                        onClick={() => remove(index)}
                        className="p-0 text-danger"
                      >
                        Remove
                      </Button>
                    </div>
                  </Col>
                </Row>
              );
            })}
          </>
        );
      }}
    </FieldArray>
  );
}

export default CandidateEducationForm;
